module.exports = __webpack_public_path__ + "static/media/estudiante.de17e1ab.png";